const model = window.model;

// 1 开发模式  2 测试模式  3 线上模式
const keyObj = {
    1:'dev',
    2:'test',
    3:"online"
}
const webUrl = {
    // 开发模式
    dev:{
        GH:'http://saas7.71baomu.com',
        kuaifu:'http://www.71baomu.com',
        supplier:"http://192.168.10.79:8077", // 汉波
        sass:"https://api.saas.71baomu.com",  // sass平台
        pn:"https://hwpnumber.eiisys.com/pnapp",  // 隐私号码后台
        eiisys_supplier:"https://peiisys.eiisys.com/html/supplier-entry.html",  // 海翕云对应官网
        bar:'http://bar.71baomu.com',
        lingxi:'http://lx.71baomu.com/Activity/show_user_info_iframe/order_id/'
    },
    // 测试模式
    test:{
        GH:'https://saas7.71baomu.com',
        kuaifu:'https://www.71baomu.com',
        supplier:"https://hwsupplier.eiisys.com", // 华为云 
        sass:"https://api.saas.71baomu.com",  // sass平台
        pn:"https://hwpnumber.eiisys.com/pnapp",  // 隐私号码后台
        eiisys_supplier:"https://peiisys.eiisys.com/html/supplier-entry.html",  // 海翕云对应官网
        bar:'http://bar.71baomu.com',
        lingxi:'http://lx.71baomu.com/Activity/show_user_info_iframe/order_id/'
    },
    // 线上模式
    online:{
        GH:'http://saas7.53kf.com',
        kuaifu:'http://www.kuaifuwang.cn',
        supplier:"https://supplier.eiisys.com", // 
        sass:"https://api.saas.53kf.com",
        eiisys_supplier:"https://www.eiisys.com/supplier-entry.html",  // 海翕云对应官网
        bar:'https://bar.53kf.com',
        lingxi:'http://www.lingsign.cn/Activity/show_user_info_iframe/order_id/'
    },
}




export default webUrl[keyObj[model]]
